<div class="player" [class.player-cliente]="cliente">
  <button type="button" class="player-btn" [class.player-btn-tocando]="tocando()" [attr.aria-label]="tocando() ? 'Pausar áudio' : 'Tocar áudio'" (click)="alternar($event)">
    @if (carregando()) {
      <span class="player-spinner"></span>
    } @else {
      <img src="./assets/icones/redesign/modulos/chat/components-message/audio-play.svg" alt="" class="player-icone-branco player-icone-play" />
      <img src="./assets/icones/redesign/modulos/chat/components-message/audio-pausar.svg" alt="" class="player-icone-branco player-icone-pausa" />
    }
  </button>
  <div class="player-onda" [class.player-onda-arrastando]="arrastando()" role="slider" tabindex="0" aria-label="Posição do áudio"
      [attr.aria-valuenow]="atual()" [attr.aria-valuemin]="0" [attr.aria-valuemax]="duracao()" [attr.aria-valuetext]="tempoExibido()"
      (pointerdown)="aoPressionarOnda($event)" (pointermove)="aoMoverOnda($event)"
      (pointerup)="aoSoltarOnda($event)" (pointercancel)="arrastando.set(false)"
      (click)="$event.stopPropagation()" (keydown)="aoTeclarOnda($event)">
    @for (altura of barras; track $index) {
      <span class="player-barra" [style.height.%]="altura * 100"
            [style.--preenchido]="preenchimentoBarra($index)"></span>
    }
    <span class="player-marcador" [class.player-marcador-ativo]="tocando() || arrastando() || atual() > 0"
          [style.left.%]="progresso() * 100"></span>
  </div>

  <div class="player-info">
    <span class="player-tempo">{{ tempoExibido() }}</span>
    @if (tocando()) {
      <button type="button" class="player-velocidade" aria-label="Velocidade do áudio" @surgir (click)="trocarVelocidade($event)">
        {{ velocidade() === 1.5 ? '1,5' : velocidade() }}x
      </button>
    }
  </div>

  <audio #audio preload="metadata" [src]="src"
        (loadedmetadata)="aoCarregarMetadados()" (durationchange)="aoMudarDuracao()"
        (timeupdate)="aoAtualizarTempo()" (ended)="aoTerminar()"
        (pause)="tocando.set(false)" (play)="acompanharReproducaoPublico()"></audio>
</div>
